export class ArbeitszeitBeginnendeSettingDao {
  constructor(beginn: string, ende: string) {
    this.beginn = beginn;
    this.ende = ende;
  }
  beginn: string;
  ende: string;
}
